import React, { Fragment } from 'react';
import styled from 'styled-components';
import { faInfoCircle } from '@fortawesome/free-solid-svg-icons';
import Tooltip from '@common-components/tooltip/Tooltip';
import Button from '@common-components/button/Button';
import { INPUT_TYPES } from '@common-components/form/constants/fieldTypes';
import { ConditionalRendering } from '@common-components/conditional-rendering';
import useSelfDesignationOtpRole from '../../../hooks/useSelfDesignationOtpRole';

const StyledTooltipContainer = styled.span`
    .ga-tooltip-container {
        padding: 10px;
        color: ${({ theme }) => theme.gray3};
    }
`;

export const RenderOneMatchFoundToBeDesignated = ({ onAuthenticateConsumerByOtp, agentOtpFeatureEnabled, edeSearchResult, backToDashboard, maskedSSN }) => {
    const {
        primaryHousehold:{
            firstName,
            lastName,
            phone,
            ssn,
            dob,
            email,
            address
        }
    } = edeSearchResult;
    
    const { role } = useSelfDesignationOtpRole();

    return(
        <div className='gi-panel desktop:grid-col-fill tablet:grid-col-fill mobile-lg:grid-col-12 grid-col-12' id="ede-search-result__found-records">
            {
                <Fragment>
                    <div className="member__name margin-l-20">
                        <h3>{firstName} {lastName}</h3>
                    </div>
                    <div className='grid-row flex-row grid-offset-1' id='ede-search-result__member-info'>
                        { dob &&
                            <Fragment>
                                <div className='grid-col-3 ede-search-result__member-info label'>DOB</div>
                                <div className='grid-col-9 ede-search-result__member-info value' id='ede-search-result__member-info__dob'>{dob}</div>
                            </Fragment>
                        }
                        { address && (address.address1 || address.address2 || address.city || address.state || address.zip) &&
                            <Fragment>
                                <div className='grid-col-3 ede-search-result__member-info label'>Address</div>
                                <div className='grid-col-9 ede-search-result__member-info value' id='ede-search-result__member-info__address'>{`${address.address1}${address.address2!==null ? `' ' ${address.address2}`: ''}, ${address.city}, ${address.state} ${address.zip}`}</div>
                            </Fragment>
                        }
                        { phone &&
                            <Fragment>
                                <div className='grid-col-3 ede-search-result__member-info label'>Phone</div>
                                <div className='grid-col-9 ede-search-result__member-info value' id='ede-search-result__member-info__phone'>{phone}</div>
                            </Fragment>
                        }
                        { email &&
                            <Fragment>
                                <div className='grid-col-3 ede-search-result__member-info label'>Email</div>
                                <div
                                    className='grid-col-9 ede-search-result__member-info ede-search-result__member-info--value'
                                    id='ede-search-result__member-info__email'>{email}</div>
                            </Fragment>
                        }
                        { ssn &&
                            <Fragment>
                                <div className='grid-col-3 ede-search-result__member-info label'>SSN</div>
                                <div className='grid-col-9 ede-search-result__member-info ede-search-result__member-info--value' id='ede-search-result__member-info__ssn'>{maskedSSN}</div>
                            </Fragment>
                        }

                    </div>

                    <div className='grid-col-12 action__btn__wrapper'>
                        <Button
                            {...{
                                id: 'cancel-btn',
                                name: 'cancelBtn',
                                type: INPUT_TYPES.BUTTON,
                                outerClass: ['margin-b-20', 'margin-r-10', 'display-inline'],
                                classes: ['gi-button__secondary'],
                                btnText: 'selfDesignation.search.action-btn.cancel',
                                handleClick: backToDashboard
                            }}

                        />
                        <Button
                            {...{
                                id: 'become-AOR-btn',
                                name: 'becomeAORBtn',
                                type: INPUT_TYPES.BUTTON,
                                outerClass: ['margin-b-20', 'display-inline'],
                                classes: ['gi-button__primary'],
                                btnText:  agentOtpFeatureEnabled ? `selfDesignation.${role}.search.action-btn.authenticateByOtp` : 'selfDesignation.search.action-btn.becomeAOR' ,
                                handleClick: onAuthenticateConsumerByOtp
                            }}

                        />
                        <ConditionalRendering isTrue={ agentOtpFeatureEnabled }>
                            <StyledTooltipContainer>
                                <Tooltip 
                                    content={`selfDesignation.${role}.search.searchResult.info.tooltip`}
                                    icon={faInfoCircle}
                                />
                            </StyledTooltipContainer>
                        </ConditionalRendering>
                    </div>
                </Fragment>
            }
        </div>
    );
};



